module.exports = __webpack_public_path__ + "img/pr-12.ec790ce5.png";